export const DURATION_DEFAULT_LENGTH_SECONDS = 6;
export const PLACEHOLDERS = [
  'Skip walk',
  'Running jump',
  'Salsa dancing',
  'Peace sign',
  'Punch',
  'Dodge',
];

export const PLACEHOLDERS_SESSION = [
  'Add a bow at the end',
  'Make it longer',
  'Then put your arms in the air',
  'Make it much shorter',
];

export const PLACEHOLDERS_POSE = [
  'T-pose',
  'Standing pose',
  'Walking pose',
  'Running pose',
  'Jumping pose',
  'Dancing pose',
  'Fighting pose',
];
